export default __webpack_public_path__ + "assets/images/c2d931f8b531bc8ea1ee3bcc7f25cb38.png";